define.alias("shared/components/shared/modal/banner", "media/components/shared/modal/banner");